import React from 'react';

import { bemBlock } from '../../modules/bem';

import { useTableContext } from './TableContext';

import './TableRow.less';

const block = bemBlock('table-row');

export type TableRowProps = React.HTMLAttributes<HTMLTableRowElement> & {
  hoverable?: boolean;
  spacer?: boolean;
  static?: boolean;
};

export const TableRow = React.forwardRef<HTMLTableRowElement, TableRowProps>(function TableRow(
  { className, hoverable = false, spacer = false, static: isStatic = false, ...passProps },
  ref,
) {
  const { shouldVirtualize } = useTableContext();

  return (
    <tr
      ref={ref}
      className={block({
        modifiers: {
          spacer,
          hoverable,
          static: isStatic,
          virtualized: shouldVirtualize && !isStatic,
        },
        extra: className,
      })}
      {...passProps}
    />
  );
});
